// Filtering and pagination happen server-side (see App\Scopes\ResourceFilter).
// This only submits the form when the topic changes and keeps the URL clean.
class FilterSearch {
  constructor(form) {
    this.form = form
    this.select = form.querySelector('.reports-filter__dropdown')
    this.input = form.querySelector('.reports-filter__search-input')
  }

  init() {
    if (this.select) {
      this.select.addEventListener('change', () => this.form.requestSubmit())
    }

    this.form.addEventListener('submit', () => {
      // Leave empty/default values out of the query string
      if (this.select && this.select.value === 'all') this.select.disabled = true
      if (this.input && this.input.value.trim() === '') this.input.disabled = true
    })

    // Re-enable fields if the page is restored from the back/forward cache
    window.addEventListener('pageshow', () => {
      if (this.select) this.select.disabled = false
      if (this.input) this.input.disabled = false
    })
  }
}

export default FilterSearch
